const CART_STORAGE_KEY = "comprartodoCart";

function readCart() {
    try {
        const raw = localStorage.getItem(CART_STORAGE_KEY);
        return raw ? JSON.parse(raw) : [];
    } catch {
        return [];
    }
}

function writeCart(items) {
    localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(items));
    window.dispatchEvent(new CustomEvent("comprartodo-cart-updated"));
}

export function getCartItems() {
    return readCart();
}

export function getCartItemCount() {
    return readCart().reduce((sum, item) => sum + (item.quantity || 1), 0);
}

export function addProductToCart(product, quantity = 1) {
    const cart = readCart();
    const existing = cart.find((item) => item.id === product.id);

    if (existing) {
        existing.quantity = (existing.quantity || 1) + quantity;
    } else {
        cart.push({
            id: product.id,
            nameKey: product.nameKey,
            price: product.price,
            currency: product.currency,
            image: product.images?.[0] ?? product.image,
            quantity,
        });
    }

    writeCart(cart);
    return cart;
}
